import { IPermissionMatrix } from '@directives/has-permissions/permission-matrix/index';
import { UserRole } from '@models/enums/user-role.enum';

export type usersAdminPermissionType = 'users_admin_view';

export const usersAdminPermissionMatrix: IPermissionMatrix<usersAdminPermissionType> = {
  users_admin_view: [UserRole.admin]
};
